// Instacart order CSV. Mirrors scripts/loaders.py::load_instacart.
//
// No standard Instacart export — we accept either an email-receipt
// parser output (Date / Store / Total) or any CSV with Date + Store/
// Retailer + Total/Amount columns.
//
// Sign: orders are outflows → positive (expense).

import {
  type Transaction,
  newTransaction,
  makeId,
  parseAmount,
  parseDate,
  normalizeVendor,
} from "../common.js";
import { parseCsv, toDictRows, findHeaderIndex } from "../csv.js";

function pick(row: Record<string, string>, ...keys: string[]): string {
  for (const k of keys) {
    const v = row[k];
    if (v !== undefined && v !== "") return v;
  }
  return "";
}

export async function loadInstacart(
  text: string,
  filename: string,
): Promise<Transaction[]> {
  const rows = parseCsv(text);
  const headerIdx = findHeaderIndex(rows, ["Date"]);
  if (headerIdx < 0 || headerIdx >= rows.length - 1) return [];
  const dicts = toDictRows(rows[headerIdx], rows.slice(headerIdx + 1));

  const out: Transaction[] = [];
  for (const row of dicts) {
    const date = parseDate(pick(row, "Date", "Order Date"));
    if (!date) continue;
    const store = (pick(row, "Store", "Retailer") || "Instacart").trim();
    const amount = parseAmount(pick(row, "Total", "Amount") || "0");
    const description = `Instacart - ${store}`;

    const id = await makeId("instacart", "instacart", date, amount, description);
    out.push(
      newTransaction({
        id,
        date,
        vendor_raw: description,
        vendor_key: normalizeVendor(description),
        amount: Math.round(amount * 100) / 100,
        portal: "instacart",
        account: "instacart",
        account_kind: "debit",
        source_file: filename,
        raw: row,
      }),
    );
  }
  return out;
}
